// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label--EhgM4","Icon":"Icon--2lGr3"};